import {BottomNavigation, BottomNavigationAction} from '@material-ui/core';
import AssessmentIcon from '@material-ui/icons/Assessment';
import BallotRoundedIcon from '@material-ui/icons/BallotRounded';
import EmailSharpIcon from '@material-ui/icons/EmailSharp';
import GroupIcon from '@material-ui/icons/Group';
import RouterSharpIcon from '@material-ui/icons/RouterSharp';
import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useAuth0} from '../../../auth/react-auth0-spa';
import {localized} from '../../../state/i18n/i18n';
import {decodeToken} from '../../../utilities/auth-helper';
import './app-drawer.scss';

const AppDrawer: React.FC = () => {
  let history = useHistory();
  const {getTokenSilently} = useAuth0();
  const [isAdmin, setIsAdmin] = useState(false);
  const {pathname} = history.location;

  const onChangeEvent = (event: any, newValue: any) => {
    history.push(newValue);
  };

  async function hasAccess() {
    let token = await getTokenSilently();
    let jwtToken = decodeToken(token);
    setIsAdmin(jwtToken.permissions.includes('admin'));
  }

  useEffect(() => {
    const checkHasAccess = async () => {
      await hasAccess();
    };
    checkHasAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BottomNavigation
      value={pathname}
      onChange={onChangeEvent}
      showLabels={true}
      className={'mobile bottomNavigation shadowApp'}>
      <BottomNavigationAction
        showLabel={true}
        label={localized('Data')}
        value="/devices"
        icon={<RouterSharpIcon className="blueIcon" />}
      />
      <BottomNavigationAction
        showLabel={true}
        label={localized('Notification')}
        value="/notification"
        icon={<EmailSharpIcon className="blueIcon" />}
      />
      <BottomNavigationAction
        showLabel={true}
        label={localized('Devices')}
        value="/management"
        icon={<BallotRoundedIcon className="blueIcon" />}
      />
      <BottomNavigationAction
        showLabel={true}
        label={localized('TeracomDevices')}
        value="/teracomdevices"
        icon={<AssessmentIcon className="blueIcon" />}
      />
      {isAdmin && (
        <BottomNavigationAction
          showLabel={true}
          label={localized('Users')}
          value="/users"
          icon={<GroupIcon className="blueIcon" />}
        />
      )}
    </BottomNavigation>
  );
};
export default AppDrawer;
